import { AgGridReact } from "ag-grid-react";
import React, { useMemo, useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Them
import { Box, Typography } from "@mui/material";
import TrashIcon from "../../../../assets/SVG/trashIcon";
import { removeAdvice, removeExperiment } from "../../../../api/area";

export default function TableLibray({ rowData, setRowData, moduleId }) {
  const [colDefs] = useState([
    {
      headerName: "ردیف",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 100,
    },
    {
      field: "experiment",
      headerName: "نام خدمت",
      width: 300,
    },
    {
      field: "description",
      headerName: "علت درخواست",
      width: 300,
    },
    {
      field: "expireAt",
      headerName: "عملیات",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" gap="10px" alignItems="center">
            <Box
              width={"60px"}
              height="40px"
              textAlign="center"
              bgcolor="var(--emr-red)"
              px="10px"
              borderRadius={"15px"}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                // setDeleteModal(true);
                // setDataRowEdit(x.data.patientInfo);
                // console.log(x.data.id);
                removeExperiment(
                  window.location.search.split("?", 3)[1].split("&", 3)[0],
                  moduleId,
                  window.location.search.split("?", 3)[1].split("&", 4)[3],
                  x.data.id
                )
                  .then(() => {
                    setRowData((z) => {
                      let array = [...z];

                      array = array.filter((item) => item.id !== x.data.id);

                      return array;
                    });
                  })
                  .catch(() => {});
              }}
            >
              <Typography color="white" fontFamily="Shabnam">
                {"حذف"}
              </Typography>
              <TrashIcon color="white" />
            </Box>
          </Box>
        );
      },
    },
  ]);

  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
  }));
  //   console.log(rowData);
  return (
    <>
      <Box bgcolor={"white"} p="15px 10px " mb="-15px" mt="20px">
        <Typography color={"var(--emr-darkblue)"} fontWeight="bold">
          {"جدول نسخه های ازمایشگاه"}
        </Typography>
      </Box>
      <div className="ag-theme-quartz" style={{ height: 300, marginTop: 10 }}>
        <AgGridReact
          //   pagination={true}
          //   ref={gridRef}
          rowHeight={60}
          enableRtl={true}
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          // pagination={true}
          //   rowSelection="multiple"
          //   onSelectionChanged={(event) => console.log("Row Selected!")}
          //   onCellValueChanged={(event) =>
          //     console.log(`New Cell Value: ${event.value}`)
          //   }
        />
      </div>
    </>
  );
}
